module.exports = __webpack_public_path__ + "media/bootstrap-icons/hexagon-3a8a887b.svg";